var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEditFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "currentColor",
    viewBox: "0 0 25 25",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.257 24.02h5.568L20.52 9.352l-5.613-5.613L.258 18.446v5.574ZM16.001 2.642l5.616 5.616 1.465-1.463a3.95 3.95 0 0 0 1.172-2.826 3.935 3.935 0 0 0-1.185-2.82 3.988 3.988 0 0 0-5.607.026l-1.46 1.467Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEditFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EditFilled.e4de0fb9307a4bf056c30d4236e5bc73.svg";